import { configOptions } from '../../helpers/axios';
import clientAxios from './../../config/axios';
import { LoanP2P } from './models/LoanP2P';
import { CreateLoanP2PRequest } from './models/dtos/CreateLoanP2PRequest';
import { GetAllLoansresponse } from './models/dtos/GetAllLoansResponse';

export const createLoanP2P = (token: string, loan: CreateLoanP2PRequest) => {
  const url = `/loans/p2p?country=${process.env.REACT_APP_ENV_COUNTRY}`;
  return clientAxios.post(url, loan, configOptions(token));
};

export const acceptLoansP2P = (
  token: string,
  transfer_id: number,
  accepted_keys: number[]
) => {
  const url = `/loans/p2p/accept?country=${process.env.REACT_APP_ENV_COUNTRY}`;
  const payload = {
    p2p_transfer_keys: accepted_keys,
    p2p_transfer_id: transfer_id,
  };
  return clientAxios.put(url, payload, configOptions(token));
};
export const cancelLoansP2P = (token: string, transfer_id: number) => {
  const url = `/loans/p2p/cancel?country=${process.env.REACT_APP_ENV_COUNTRY}`;
  const payload = {
    p2p_transfer_id: transfer_id,
  };
  return clientAxios.put(url, payload, configOptions(token));
};
export const getAllLoans = async (
  token: string,
  { filter, pagination }: any
): Promise<GetAllLoansresponse> => {
  const filterTmp = filter ?? '';
  const complement = pagination.page
    ? `page=${pagination.page}&items_per_page=${pagination.rowsPerPage}${filterTmp}`
    : `all=1${filterTmp}`;
  const url = `/loans?country=${process.env.REACT_APP_ENV_COUNTRY}&${complement}`;
  const { data } = await clientAxios.get(url, configOptions(token));
  data.LoanP2P.map((loanP2P: LoanP2P) => {
    loanP2P.created = new Date(loanP2P.created);
    loanP2P.modified = new Date(loanP2P.modified);
    loanP2P.date_repayment = new Date(loanP2P.date_repayment);
    loanP2P.complete_return_date = loanP2P.complete_return_date
      ? new Date(loanP2P.complete_return_date)
      : null;
    return loanP2P;
  });
  return data;
};

export const getUserLoan = (token: string, filter: any) => {
  const url = `/loand_user/?country=${process.env.REACT_APP_ENV_COUNTRY}${filter}`;
  return clientAxios.get(url, configOptions(token));
};

export const getUserLoanP2P = async (
  token: string,
  { filter, pagination }: any
) => {
  const filterTmp = filter ?? '';
  const complement = pagination.page
    ? `page=${pagination.page}&items_per_page=${pagination.rowsPerPage}${filterTmp}`
    : `all=1${filterTmp}`;
  const url = `/loans/p2p/?country=${process.env.REACT_APP_ENV_COUNTRY}&${complement}`;
  const { data } = await clientAxios.get(url, configOptions(token));
  if (!data) {
    data.loans_p2p.map((loanP2P: any) => {
      loanP2P.created =
        loanP2P.created != null ? new Date(loanP2P.created) : '';
      loanP2P.finished =
        loanP2P.finished != null ? new Date(loanP2P.finished) : '';
      return loanP2P;
    });
  }
  return data;
};

export const getSessionLoans = (token: string) => {
  const url = `/loans/session?country=${process.env.REACT_APP_ENV_COUNTRY}`;
  return clientAxios.get(url, configOptions(token));
};
